
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2.vue'
import GoodsListPage from '@/components/GoodsListPage'
// import {
//   jobPage,
//   jobDetail,
//   jobResumeTemplate,
//   jobNotice,
//   articleDetail,
//   qrJobInfo,
// } from "@/api/common";
import { downFile } from '@/utils/validate'

export default {
	components: {
		TitleBox,
		TitleBox2,
		GoodsListPage
	},
	props: {
		components: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			showJobResumeTemplateBtn: false,
			disabled: false,
			loading: false,
			dialogVisible: false,
			dialogVisibleMethod: false,
			jobNoticeContent: null,
			jobsList: [],
			jobDetailData: null,
			pageInfo: {
				total: 0,
				page: 1,
				pageSize: 10
			},
			hrImgList: []
		}
	},
	methods: {
		getQrJobInfo() {
			this.$api.qrJobInfo().then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				if (res.data) this.hrImgList = res.data.imgList
			})
		},
		// 下一页
		handleCurrentChange(val) {
			this.pageInfo.page = val
			this.getJobPage()
		},
		// 选择每页多少
		handleSizeChange(val) {
			this.pageInfo.page = 1
			this.pageInfo.pageSize = val
			this.getJobPage()
		},
		download() {
			this.$api.jobResumeTemplate().then(res => {
				if (!res.success && !res.data) {
					this.$message.error(res.info)
					return
				}
				downFile(res.data)
				this.disabled = true
				this.$message.success(res.info)
			})
		},
		closeDialog() {
			this.disabled = false
		},
		go() {
			this.$api.jobNotice().then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.jobNoticeContent = res.data
				this.dialogVisibleMethod = true
			})
		},
		getJobDetail(id) {
			this.loading = true
			let p = {
				action: {
					id: id
				}
			}
			this.isTemplate()
			this.$api.jobDetail(p).then(res => {
				this.loading = false
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.jobDetailData = res.data
				this.dialogVisible = true
			})
		},
		isTemplate() {
			this.$api.jobResumeTemplate().then(res => {
				if (res.data) this.showJobResumeTemplateBtn = true
			})
		},
		getJobPage() {
			let p = {
				action: {},
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			this.$api.jobPage(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.jobsList = res.data.records
				this.pageInfo.total = Number(res.data.total)
				this.pageInfo.page = res.data.page
			})
		}
	},
	mounted() {
		this.getJobPage()
		this.getQrJobInfo()
	}
}
